<template>
  <div class="copyright-wrap">
    <div class="b">
      <ul class="nav">
        <li v-for="(link,i) in links" :key='i'>
          <a :href="link.link" target="_blank">{{link.name}}</a>
        </li>
      </ul>
      <div class="copyright">
        © 2005-2018 三利达旗下弓箭行业电商平台 版权所有，并保留所有权利。
	    </div>
      <div class="copyright">
        河南省焦作市焦辉路三利达弓箭文化旅游区       ICP备案证书号： <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
        豫ICP备06007794号-2</a> 公安备案号：41081102000024
      </div>
      <div class="copyright">
        <a href="https://uweb.umeng.com/v1/login.php?siteid=1277693314" target="_blank">站长统计</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props:{
    links:{
      type:Array,
      default:function(){
        return []
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.copyright-wrap {
  width: 100%;
  background: #fafafa;
  .b {
    position: relative;
    min-width: 100%;
    padding: 30px 0;
    ul {
      display: flex;
      justify-content: center;
      padding: 16px 0;
      li {
        border-right: 1px solid #666;
        &:last-of-type {
          border: none;
        }
        a {
          display: block;
          padding: 0 8px;
          font-size: 12px;
          color: rgba(102, 102, 102, 1);
          text-align: center;
        }
      }
    }
    .copyright {
      margin: 0 auto;
      height: 12px;
      font-size: 12px;
      text-align: center;
      color: rgba(153, 153, 153, 1);
      margin-bottom: 10px;
    }
  }
}
</style>